<!-- eslint-disable vue/attributes-order -->
<template>
  <ClientOnly>
    <template v-if="isComponent">
      <component
        :is="isComponent"
        :key="String(route.query.id ?? '')"
        @on-confrim="smartRouter.back()"
      />
    </template>
  </ClientOnly>
</template>
<script setup lang="ts">
const dynamicComponents = {
  'support-detail': defineAsyncComponent(() => import('./SupportDetail/SupportDetail.vue')),
}

const route = useRoute()

const isComponent = computed(() => {
  const overlay = route.query.overlay as keyof typeof dynamicComponents
  return dynamicComponents[overlay] || null
})
</script>
